/* [PATCH pomoc-fe v2] Vsebina pomoči — aplikacija Delovni čas.
   Vloge: 'vsi' = vsi zaposleni; 'admin' = admin DČ (stranka z vlogo admin) in računovodja — kot meni (pnVloga).
   Vir napisov: recon v10 (15.10.2026) iz DelovniCasPage.tsx, PregledDelaDcPage.tsx, DcSkupinaPage.tsx, KadriPage.tsx na testu.
   Pravilo: samo napisi, ki obstajajo v kodi. Ob spremembi zaslona posodobi tudi to datoteko. */
import { Postopek, StranPomoci } from '../tipi';

const P_MESEC: Postopek = {
  id: 'dc.mesec', naslov: 'Vnos meseca', za: 'vsi',
  koraki: [
    'Meni **Moj mesec** — koledar meseca.',
    'Označi enega ali več dni in izberi vrsto: **Po urniku**, **Dopust**, **Bolniška**, **Delo od doma**, **Izredni dopust**, **Izobraževanje**, **Neplačan dopust** ali **Drug čas**. Izbiro razveljaviš s **Prekliči izbiro**.',
    'Ko je mesec izpolnjen, klikni **Potrdi mesec**; potrditev razveljaviš s **Prekliči potrditev**.',
  ],
};

const P_ZAKLEP: Postopek = {
  id: 'dc.zaklep', naslov: 'Zaklep meseca', za: 'admin',
  koraki: [
    'Mesec zakleneš z **Zakleni mesec**.',
    'Za popravek ga odkleneš z **Odkleni mesec**.',
  ],
};

const P_PREGLED: Postopek = {
  id: 'dc.pregled', naslov: 'Pregled dela', za: 'admin',
  koraki: [
    'Meni **Pregled dela** — po zaposlenem: **Ure**, **Stanje ur**, **Redne ure**, **Praznik**, **Dopust**, **Bolniška**, **Dodatki**, **Potni nalogi**.',
    'Izvoz: **Izvoz v Excel (Vasco)**.',
  ],
};

const P_SKUPINA: Postopek = {
  id: 'dc.skupina', naslov: 'Skupinski pregled dela', za: 'admin',
  koraki: [
    'Meni **Skupinski pregled dela** (viden, ko sta izbrani vsaj dve bazi) — isti stolpci kot Pregled dela, z dodatnim stolpcem **Podjetje**.',
    'Izvoz za vse izbrane baze: **Izvoz ZIP (Vasco)**.',
  ],
};

const P_ZAPOSLENI: Postopek = {
  id: 'dc.zaposleni', naslov: 'Zaposleni', za: 'admin',
  koraki: [
    'Meni **NASTAVITVE → Šifranti**: **Dodaj zaposlenega** ali **Dodaj sebe kot zaposlenega** → **Shrani**.',
    'Več naenkrat: **Uvoz iz Excela** → **Prenesi predlogo** → izpolni → **Predogled** → **Potrdi uvoz**.',
    'Seznam: **Šifra**, **Priimek in ime**, **Davčna**, **Aktiven**, **Uporabnik**; filter **Aktivni** / **Neaktivni** / **Vsi**.',
    'Pri zaposlenem nastaviš delovni čas → **Shrani delovni čas**.',
  ],
};

const P_NASTAVITVE: Postopek = {
  id: 'dc.nastavitve', naslov: 'Nastavitve delovnega časa', za: 'admin',
  koraki: [
    'Meni **NASTAVITVE → Nastavitve** — samodejna opozorila (opomniki).',
    'Vrste odsotnosti lahko dopolniš s podvrstami (**+ Dodaj podvrsto**, npr. starševsko varstvo) → **Shrani**.',
  ],
};

export const DELOVNI_CAS: StranPomoci[] = [
  {
    kljuc: 'dc.mesec', naslov: 'Moj mesec', za: 'vsi',
    ujema: (pot) => pot === '/moj-mesec',
    opis: 'Mesečna evidenca delovnega časa in odsotnosti.',
    postopki: [P_MESEC, P_ZAKLEP],
  },
  {
    kljuc: 'dc.pregled', naslov: 'Pregled dela', za: 'admin',
    ujema: (pot) => pot === '/dc-pregled',
    opis: 'Mesečni pregled ur in odsotnosti zaposlenih ter izvoz v Excel (Vasco).',
    postopki: [P_PREGLED, P_ZAKLEP],
  },
  {
    kljuc: 'dc.skupina', naslov: 'Skupinski pregled dela', za: 'admin',
    ujema: (pot) => pot === '/dc-skupina',
    opis: 'Pregled dela za več podjetij hkrati.',
    postopki: [P_SKUPINA],
  },
  {
    kljuc: 'dc.sifranti', naslov: 'Šifranti', za: 'admin',
    ujema: (pot) => pot === '/pn-sifranti',
    opis: 'Zaposleni in njihov delovni čas.',
    postopki: [P_ZAPOSLENI],
  },
  {
    kljuc: 'dc.nastavitve', naslov: 'Nastavitve', za: 'admin',
    ujema: (pot) => pot === '/kadri',
    opis: 'Nastavitve delovnega časa.',
    postopki: [P_NASTAVITVE, P_ZAPOSLENI],
  },
];
